export default __webpack_public_path__ + "static/media/sobreNosTable.911d1813.jpg";